export default __webpack_public_path__ + "static/media/MS001.9929fefa.mp3";